import { render, staticRenderFns } from "./MonthlyLandingView.vue?vue&type=template&id=c83d61a6&scoped=true&"
import script from "./MonthlyLandingView.vue?vue&type=script&lang=js&"
export * from "./MonthlyLandingView.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyLandingView.vue?vue&type=style&index=0&id=c83d61a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83d61a6",
  null
  
)

export default component.exports